<template>
  <div>
  </div>
</template>

<script>
import { proporsalService } from "@/_services";

export default {
  name: 'ClientServiceProporsal',
  data() {
    return {
    };
  },
  created(){

     // https://dev.oliverlists.com/client-service-proposal-action/confirmation/viva?t=cbdae7f8-ee9e-4842-9bd0-c9cfa2334c02&s=6038691706867250&lang=fr-FR&eventId=0&eci=1

      if(this.$route.params.action == "confirmation" && (this.$route.params.detail == "viva" || this.$route.params.detail == "gocardless")){
          proporsalService.confirmPaymentMethod(this.$route.query)
                .then( result => {
                  if(result.payment_status == "success"){
                               this.$swal({
                                  type: "success",
                                  title: this.$t("lang.label.great"),
                                  text: this.$t("lang.label.datasavedsuccessfully"),
                                  showConfirmButton: false,
                                  timer: 1500,
                                });
                  }else{
                        this.$swal({
                          type: "error",
                          title: this.$t("lang.label.error"),
                          text: this.$t("lang.viva_payments."+result.payment_status),
                          showConfirmButton: true,
                        });
                  }

                  if(result.return_url){
                    this.$router.push(result.return_url);
                  }else{
                    this.$router.push('/login');
                  }


                })
      }else{

        if (typeof this.$route.params.action !== "undefined") {
          if (this.$route.params.action == "confirmation") {

            proporsalService
            .getPaymentMoethod(this.$route.params.detail)
            .then(result => {
              let ingenicoResponse = {
                id: this.$route.params.detail,
                ncerror: this.$route.query.NCERROR,
                ingenico_status: this.$route.query.STATUS,
                user_id: result.user_id,
                client_id: result.client_id
              };

              proporsalService.confirmPaymentMethod(ingenicoResponse)
                .then( result => {
                  // const { client_id } = ingenicoResponse.client_id;
                  // this.$router.push({ path: `/client-service-proposal/${client_id}`});
                  this.$router.push("/client-service-proposal/"+ingenicoResponse.client_id);
                })
            })
            .catch( err => {
              if(err = 'url_not_valid'){
                this.$swal({
                  type: "error",
                  title: this.$t("lang.label.error"),
                  // text: this.$t(
                  //   "lang.label.error"
                  // ),
                  showConfirmButton: true,
                });
              }
            })
          } else {
            // console.log('change....');
            //this.changeHeaderTab({});
        }
      } else {
        // console.log('change....');
        //this.changeHeaderTab({});
      }
      }


  },
  methods: {
  },
};
</script>
